module.exports = __webpack_public_path__ + "static/img/kaihuhang.14dab65e.jpg";